const config = {
  env: "local",
  // apiUrl: "http://192.168.0.57:5600/api/",
   apiUrl: "https://api.astrowala.ai/api/",
};

export default config;
